// State name to abbreviation mapping
const STATE_ABBREVIATIONS: Record<string, string> = {
  alabama: "AL",
  alaska: "AK",
  arizona: "AZ",
  arkansas: "AR",
  california: "CA",
  colorado: "CO",
  connecticut: "CT",
  delaware: "DE",
  florida: "FL",
  georgia: "GA",
  hawaii: "HI",
  idaho: "ID",
  illinois: "IL",
  indiana: "IN",
  iowa: "IA",
  kansas: "KS",
  kentucky: "KY",
  louisiana: "LA",
  maine: "ME",
  maryland: "MD",
  massachusetts: "MA",
  michigan: "MI",
  minnesota: "MN",
  mississippi: "MS",
  missouri: "MO",
  montana: "MT",
  nebraska: "NE",
  nevada: "NV",
  "new hampshire": "NH",
  "new jersey": "NJ",
  "new mexico": "NM",
  "new york": "NY",
  "north carolina": "NC",
  "north dakota": "ND",
  ohio: "OH",
  oklahoma: "OK",
  oregon: "OR",
  pennsylvania: "PA",
  "rhode island": "RI",
  "south carolina": "SC",
  "south dakota": "SD",
  tennessee: "TN",
  texas: "TX",
  utah: "UT",
  vermont: "VT",
  virginia: "VA",
  washington: "WA",
  "west virginia": "WV",
  wisconsin: "WI",
  wyoming: "WY",
};

/**
 * Converts a state name to its two-letter abbreviation
 * @param stateName - The full state name (case insensitive)
 * @returns The two-letter state abbreviation in uppercase, or undefined if not found
 */
export const getStateAbbreviation = (stateName: string): string | undefined => {
  if (!stateName) return undefined;

  const normalizedName = stateName.toLowerCase().trim();
  return STATE_ABBREVIATIONS[normalizedName];
};

/**
 * Gets the current state abbreviation from the VITE_STATE_NAME environment variable
 * @returns The two-letter state abbreviation in uppercase, or undefined if not found
 */
export const getCurrentStateAbbreviation = (): string | undefined => {
  const stateName = import.meta.env.VITE_STATE_NAME;
  return getStateAbbreviation(stateName);
};
